<template>
  <v-row no-gutters>
    <v-col cols="12">
      <admin-wrapper
        :inputs="inputs"
        @save="saveInformation"
        :is-custom-saving="isSaving"
        :disabled="disabled"
        disable-sticky-buttons
      >
        <template #[`informationContent.input`]>
          <v-col cols="6">
            <tiptap-vuetify
              :disabled="disabled"
              :extensions="extensions"
              v-model="content"
              :placeholder="$i18n.t('admin.infoPlaceholder')"
              :card-props="{ flat: true, outlined: true }"
              style="text-align: left"
            />
            <v-alert dense text type="info" class="mt-4 text-left">
              <span class="text-left text-body-2">{{ $i18n.t('admin.informationHint') }}</span>
            </v-alert>
          </v-col>
        </template>
      </admin-wrapper>
    </v-col>
  </v-row>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import {
  TiptapVuetify,
  Bold,
  Italic,
  Underline,
  Paragraph,
  Heading,
  History,
  HardBreak,
  Link,
  ListItem,
  BulletList,
  OrderedList,
} from 'tiptap-vuetify';
import { call, get } from 'vuex-pathify';
export default {
  name: 'InformationAdmin',
  components: { AdminWrapper, TiptapVuetify },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isSaving: false,
    content: '',
    extensions: [
      Bold,
      Italic,
      Underline,
      Paragraph,
      [
        Heading,
        {
          options: {
            levels: [1, 2, 3],
          },
        },
      ],
      HardBreak,
      Link,
      History,
      ListItem,
      BulletList,
      OrderedList,
    ],
  }),
  computed: {
    informationContent: get('admin/settingsValues@info_module_content'),
    inputs() {
      return [
        {
          name: 'informationContent',
          translationPath: 'admin.informationContent',
          subtitle: 'admin.informationContentSubtitle',
          isCustom: true,
          align: 'start',
        },
      ];
    },
  },
  methods: {
    editSingleSetting: call('admin/editSingleSetting'),
    async saveInformation() {
      this.isSaving = true;
      await this.editSingleSetting({ key: 'info_module_content', body: { value: this.content } }),
        this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
          message: this.$i18n.t('success.setInformationSettings'),
        });
      this.content = this.informationContent;
      this.isSaving = false;
    },
  },
  mounted() {
    this.content = this.informationContent;
  },
};
</script>

<style scoped></style>
